import React from "react";
import ReviewCard from "./ReviewCard/ReviewCard";
import styles from "./ReviewSection.module.scss";
import { Link } from "react-router-dom";

const reviews = [
  {
    name: "Dmitriy KDM",
    text: "Eine professionelle und fürsorgliche Werkstatt, die immer bereit ist, bei der Reparatur und Wartung von Automatikgetrieben zu helfen. Erfahrene Fachleute lösen alle Probleme schnell und zuverlässig, um eine schnelle und qualitativ hochwertige Serviceleistung zu gewährleisten. Ohne Zweifel empfehle ich diese Werkstatt allen Autofahrern!",
    rating: 5,
  },
  {
    name: "Uwe Fischer",
    text: "Ein DSG Service nach meiner Vorstellung! Sehr kompetente und freundliche Mitarbeiter. Besonders freundlich und zuvorkommend mit viel Fachwissen, Hilfsbereitschaft und Zuverlässigkeit kam mir Herr Pavel bei meinen Anliegen entgegen. Ich kann DSG Getriebeservice Hixa uneingeschränkt empfehlen!",
    rating: 5,
  },
  {
    name: "EXCHANGE WORK",
    text: "Alles ist super zu empfehlen, sehr schnell das Problem gelöst, echte Alles ist super zu empfehlen, sehr schnell das Problem gelöst, echte Profis!",
    rating: 5,
  },
  {
    name: "Atila Alvin Beck",
    text: "Hixa UG hat meine DSG-Mechatronik angekauft. Guter Kontakt und gut erreichbar. Die Geschäftsführerin und Mitarbeiter sind wirklich sehr freundlich, auch als ich im Ton berechtigterweise etwas rauer geworden bin. Das erlebe ich selten, dass Unternehmen dann freundlich bleiben. Es gab leider nur unnötige Verzögerungen bei der Auszahlung und Abmachungen wurden nicht so",
    rating: 5,
  },
  {
    name: "Dario Matanovic",
    text: "Thanks you very much all is Works, good work and staff, my DSG od working perfect",
    rating: 5,
  },
];

const ReviewsSection: React.FC = () => {
  return (
    <div className="container">
      <div className={`sideP88 titleCont ${styles.mainReviewBlock}`}>
        <div className="titleBlock halfBlock">
          <h2>Kunden­bewertungen</h2>
        </div>
        <Link to="/reviews" className={styles.buttonLink}>
          <button
            className={`${styles.buttonW} commonButton buttonMd buttonWhiteBg`}
          >
            Alle Bewertungen
          </button>
        </Link>
      </div>

      <div className={`${styles.reviewSection} sideP88`}>
        <div className={`${styles.reviewsSection}`}>
          {reviews.map((review, index) => (
            <ReviewCard
              key={index}
              name={review.name}
              text={review.text}
              rating={review.rating}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReviewsSection;
